<template>
    <div id="slider-container" v-on:click="showImg">
        <Loading v-if="this.loading" id="slider-loader" type="area"/>
        <b-carousel
        v-else
        id="carousel-1"
        class="slider"
        v-model="slide"
        :interval="6000"
        controls
        indicators
        img-width="1084"
        img-height="360"
        @sliding-start="onSlideStart"
        @sliding-end="onSlideEnd"
        v-b-modal.modal-tall
        >
        <b-carousel-slide v-for="(image, key) in sliderImages" :key="key"
            :img-src="image"
        ></b-carousel-slide>
        </b-carousel>
        <b-modal no-fade hide-header hide-footer size="xl" id="modal-tall" centered >
          <img id="viewing-img" :src="src" width="1084" height="360"/>
        </b-modal>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Loading from '../components/Loading'

export default {
  name: 'Slider',
  components: {
    Loading
  },
  data () {
    return {
      slide: 0,
      sliding: null,
      loading: true,
      index: 0,
      src: ''
    }
  },
  async mounted () {
    await this.loadSliderImages()
    this.loading = false
  },
  computed: {
    ...mapState('Overview', ['sliderImages'
    ])
  },
  methods: {
    ...mapActions('Overview', ['loadSliderImages']),
    onSlideStart (slide) {
      this.index = slide
      this.sliding = true
    },
    onSlideEnd (slide) {
      this.index = slide
      this.sliding = false
    },
    showImg () {
      const index = this.index
      this.src = this.sliderImages[index]
      // eslint-disable-next-line no-undef
      _paq.push(['trackEvent', 'Slider Clicked', 'Click', `Click-Img-${index + 1}`])
    }
  }
}
</script>
<style scoped>
#slider-container{
  width: 100% !important;
  height: 400px !important;
  min-width: 900px !important;
  margin: auto !important;
  padding-bottom: 10px;
}

#slider-loader{
  height: 368px !important;
}

#viewing-img{
  display: block !important;
}
.modal-backdrop {
  opacity: 0.5 !important;
}
.carousel-indicators {
  position: relative !important;
  bottom: -12px !important;
}

.carousel-indicators > li {
  background-color: rgba(0, 0,0, 0.65) !important;
}

.carousel-control-prev-icon {
  margin-right: 120px !important;
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='dark-grey' width='8' height='8'%3E%3Cpath d='M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z'/%3E%3C/svg%3E") !important;
}

.carousel-control-next-icon {
  margin-left: 120px !important;
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='dark-grey' width='8' height='8'%3E%3Cpath d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/%3E%3C/svg%3E") !important;
}
</style>
